import { useState } from 'react'
import { theme } from 'antd'
import { PlayCircleOutlined } from '@ant-design/icons'
import { FileAttachment } from '../../Contracts'

interface VideoMessageProps {
  file: FileAttachment
}

const VideoMessage = ({ file }: VideoMessageProps) => {
  const [isPlaying, setIsPlaying] = useState(false)
  const { token } = theme.useToken()

  if (isPlaying) {
    return (
      <video
        src={file.url}
        controls
        autoPlay
        style={{ borderRadius: 8, maxWidth: '100%', maxHeight: 300 }}
      />
    )
  }

  return (
    <div
      onClick={() => setIsPlaying(true)}
      style={{
        position: 'relative',
        cursor: 'pointer',
        borderRadius: 8,
        overflow: 'hidden',
        background: token.colorFillTertiary,
        width: 280,
        height: 180,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <video
        src={file.url}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        preload="metadata"
      />
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(0,0,0,0.3)',
        }}
      >
        <PlayCircleOutlined style={{ fontSize: 48, color: '#fff' }} />
      </div>
    </div>
  )
}

export default VideoMessage
